import React from 'react';
import Introduction from './components/Introduction';
import Simulation from './components/Simulation';
import Summary from './components/Summary';
import DecisionHistory from './components/DecisionHistory';
import InstructorReview from './components/InstructorReview';
import StudentReview from './components/StudentReview';
import Settings from './components/Settings';
import Prework from './components/Prework';
import Reflection from './components/Reflection';
import ReflectionReview from './components/ReflectionReview';
import PreworkDecisionHistory from './components/PreworkDecisionHistory';
import PreworkInstructorReview from './components/PreworkInstructorReview';

/** react im routes */
const routes = [
  {
    path: '',
    element: <Introduction />
  },
  {
    path: 'intro',
    element: <Introduction />
  },
  {
    path: 'simulation',
    element: <Simulation />,
    children: [
      { 
        path: 'table',
        element: <h4>Table</h4> 
      },
      { 
        path: 'graph',
        element: <h4>Graph</h4> 
      }
    ]
  },
  {
    path: 'summary',
    element: <Summary />,
  },
  {
    path: 'decisionhistory',
    element: <DecisionHistory />,
  },
  {
    path: 'instructorreview',
    element: <InstructorReview />,
  },
  {
    path: 'reflectionreview',
    element: <ReflectionReview />,
  },
  {
    path: 'studentreview',
    element: <StudentReview />,
  },
  {
    path: 'settings',
    element: <Settings />,
  },
  {
    path: 'prework',
    element: <Prework />,
  },
  {
    path: 'reflection',
    element: <Reflection/>,
  },
  {
    path: 'preworkdecisionhistory',
    element: <PreworkDecisionHistory />,
  },
  {
    path: 'preworkinstructorreview',
    element: <PreworkInstructorReview role={"instructor"} />,
  },
  {
    path: 'preworkstudentreview',
    element: <PreworkInstructorReview role={"student"}/>,
  }
]

export default routes;
